import React from "react";
//#region types
import { UtilFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { updateFormHandleValues } from "./costForwardingMarkingModel";
//#endregion
//#region components
import useCostForwardingFormSync from "./useCostForwardingFormSync";
//#endregion

/**
 * Keeps a GenericForm's cost-forwarding fields in step with the marking. It sits beside the form rather
 * than inside the step, because the step stays hidden until this has set the form's values.
 */
const CostForwardingFormHandleSync: React.FC<{ formRef: React.RefObject<FormHandles> }> = ({ formRef }) => {
  const setValues = React.useCallback(
    (update: React.SetStateAction<UtilFormTypes.CostForwardingMarking>) =>
      updateFormHandleValues(formRef.current, update),
    [formRef]
  );
  useCostForwardingFormSync(setValues);

  return null;
};

export default CostForwardingFormHandleSync;
